import { isIOS } from 'utils/platform-detectors/is-ios.util';

export const useViewportMetaContent = (): void => {
  if (isIOS()) {
    document
      ?.querySelector('[name=viewport]')
      ?.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
  }
};
